<template>
  <div class="history-search-bar">
    <el-form :model="searchForm" label-position="top">
      <el-row :gutter="20">

        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('UpgradeApplyManagement.applicantStatus')">
            <el-select v-model="searchForm.applicantStatus" filterable
                       :placeholder="$t('UpgradeApplyManagement.applicantStatusPlaceholder')" :clearable="true"
                       class="custom-tree-select-width"
                       label-position="top">
              <el-option :label="$t('UpgradeApplyManagement.statusPending')" value="pending"/>
              <el-option :label="$t('UpgradeApplyManagement.statusApproved')" value="approved"/>
              <el-option :label="$t('UpgradeApplyManagement.statusRejected')" value="rejected"/>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('UpgradeApplyManagement.applyTime')">
            <el-date-picker v-model="searchForm.applyTime" type="datetimerange" :clearable="true"
                            :start-placeholder="$t('UpgradeApplyManagement.startDatePlaceholder')"
                            :popper-options="{
   modifiers: [
        {
            name: 'flip',
            options: {
                fallbackPlacements: ['bottom'],
                allowedAutoPlacements: ['bottom'],
            }
        }
    ]
}"
                            :end-placeholder="$t('UpgradeApplyManagement.endDatePlaceholder')"/>
          </el-form-item>
        </el-col>

        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('UpgradeApplyManagement.applicantEmail')">
            <el-input v-model="searchForm.applicantEmail" filterable
                      :placeholder="$t('UpgradeApplyManagement.applicantEmailPlaceholder')" :clearable="true"
                      class="custom-tree-select-width"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" :sm="12" :md="7" :lg="4">
          <el-form-item label="&nbsp;">
            <el-button class="button-background-color" @click="search">
              {{ $t('UpgradeApplyManagement.search') }}
            </el-button>
            <el-button @click="reset" class="custom-reset-button">
              {{ $t('UpgradeApplyManagement.reset') }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import dialogMixin from "@/mixins/dialogMixin";

export default {
  data() {
    return {
      searchForm: {
        applicantStatus: '',
        applyTime: '',
        applicantEmail: '',
      },
    };
  },
  mixins: [dialogMixin],

  methods: {
    search() {
      let searchCondition = {};

      if (this.searchForm.applicantStatus) {
        // 转换状态值：pending->0, approved->1, rejected->2
        const statusMap = {
          'pending': 0,
          'approved': 1,
          'rejected': 2
        };
        searchCondition["status-eq"] = statusMap[this.searchForm.applicantStatus];
      }

      if (this.searchForm.applyTime && this.searchForm.applyTime.length === 2) {
        const [start, end] = this.searchForm.applyTime;
        searchCondition["created_at-begin"] = this.formatDate(null, null, start);
        searchCondition["created_at-end"] = this.formatDate(null, null, end);
      }

      // 根据API接口要求，使用精确匹配
      if (this.searchForm.applicantEmail) {
        searchCondition["user-email-like"] = this.searchForm.applicantEmail;
      }

      // 发送搜索请求并将搜索条件传递给父组件
      this.$emit('search', searchCondition);
    },
    reset() {
      // 重置搜索条件
      this.searchForm = {
        applicantStatus: '',
        applyTime: '',
        applicantEmail: '',
      };
      this.search();
    }
  },
};
</script>
<style scoped>

</style>
